// Team-Code → CSS-Klasse auf <html>. Die Farbwerte stehen in theme.css unter :root.team-<code>.
// Aus dem Visual System: AUT · GER · BRA · JPN · default. Erweiterbar ohne Code-Änderung
// in den Komponenten, nur diese Liste + die :root.team-*-Blöcke in theme.css updaten.

export type TeamKey = 'AUT' | 'GER' | 'BRA' | 'JPN' | 'default';

export type TeamTheme = {
  primary: string;
  accent: string;
  name: string;
};

export const teamThemes: Record<TeamKey, TeamTheme> = {
  AUT:     { primary: '#E0322B', accent: '#9E1B27', name: 'Österreich'  },
  GER:     { primary: '#333A45', accent: '#E4B73B', name: 'Deutschland' },
  BRA:     { primary: '#138A4F', accent: '#F2C400', name: 'Brasilien'   },
  JPN:     { primary: '#20307A', accent: '#E0273A', name: 'Japan'       },
  default: { primary: '#2F6FED', accent: '#7B5BFF', name: 'Standard'    },
};

export const TEAM_OPTIONS: { code: TeamKey; label: string }[] = [
  { code: 'AUT', label: 'Österreich' },
  { code: 'GER', label: 'Deutschland' },
  { code: 'BRA', label: 'Brasilien' },
  { code: 'JPN', label: 'Japan' },
];

const KNOWN_TEAM_CLASSES = new Set<string>(['aut', 'ger', 'bra', 'jpn']);

export function teamClassFor(code: string | null | undefined): string | null {
  if (!code) return null;
  const lower = code.toLowerCase();
  return KNOWN_TEAM_CLASSES.has(lower) ? `team-${lower}` : null;
}

export function applyTeamClass(code: string | null | undefined): void {
  const html = document.documentElement;
  for (const cls of Array.from(html.classList)) {
    if (cls.startsWith('team-')) html.classList.remove(cls);
  }
  const target = teamClassFor(code);
  if (target) html.classList.add(target);
}

/** Holt die Theme-Werte direkt (für Avatare, Inline-Hintergründe etc.). */
export function teamThemeOf(code: string | null | undefined): TeamTheme {
  if (!code) return teamThemes.default;
  const upper = code.toUpperCase() as TeamKey;
  return teamThemes[upper] ?? teamThemes.default;
}
